module.exports = __webpack_public_path__ + "img/MOUSTACHES 1.9ddb795.svg";